import { motion } from "framer-motion";
import { springPresets, staggerContainer, staggerItem } from "@/lib/motion";
import { TIMELINE_EVENTS } from "@/lib/index";

export function Timeline() {
  return (
    <section id="zaman-cizelgesi" className="py-12 px-4 bg-secondary/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-primary mb-2" style={{ fontFamily: "'Merriweather', serif" }}>
            📅 Tarihten Günümüze
          </h2>
          <p className="text-muted-foreground">23 Nisan'ın 106 yıllık yolculuğu</p>
          <div className="w-24 h-1 bg-primary mx-auto mt-3 rounded-full" />
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="relative"
        >
          {/* Vertical line */}
          <div className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-0.5 bg-primary/30 -translate-x-1/2 hidden sm:block" />

          <div className="space-y-8">
            {TIMELINE_EVENTS.map((event, index) => (
              <motion.div
                key={event.year}
                variants={staggerItem}
                className={`flex flex-col sm:flex-row gap-4 sm:gap-8 items-start ${
                  index % 2 === 0 ? "sm:flex-row" : "sm:flex-row-reverse"
                }`}
              >
                {/* Content */}
                <div className={`flex-1 ${index % 2 === 0 ? "sm:text-right" : "sm:text-left"}`}>
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    transition={springPresets.snappy}
                    className="bg-card border border-border rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow"
                    style={{ boxShadow: "0 4px 16px -4px oklch(0.48 0.24 12 / 0.12)" }}
                  >
                    <div className={`flex items-center gap-3 mb-2 ${index % 2 === 0 ? "sm:flex-row-reverse" : ""}`}>
                      <span className="text-2xl">{event.icon}</span>
                      <span className="text-2xl font-black text-primary" style={{ fontFamily: "'Merriweather', serif" }}>
                        {event.year}
                      </span>
                    </div>
                    <h3 className="text-lg font-bold text-foreground mb-1">{event.title}</h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">{event.description}</p>
                  </motion.div>
                </div>

                {/* Center dot */}
                <div className="hidden sm:flex items-center justify-center w-10 flex-shrink-0">
                  <div className="w-4 h-4 rounded-full bg-primary border-4 border-background shadow-md" />
                </div>

                {/* Spacer */}
                <div className="flex-1 hidden sm:block" />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
